<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getSiteConfig as fetchSiteConfig } from '@/api/home'
import { setSiteConfig } from '@/store/siteConfig'

export default {
  name: 'App',
  async created() {
    // 应用启动时获取网站配置
    try {
      const res = await fetchSiteConfig()
      if (res.code === 0 && res.data && res.data.config) {
        setSiteConfig(res.data.config)
      }
    } catch (error) {
      console.error('获取网站配置失败:', error)
    }
  }
}
</script>

<style lang="css" src="./assets/common.css">
</style>
